












import Vue from 'vue';
import Component from 'vue-class-component';
import config from '@/appConfig.json';
import CertificateService from '@/services/CertificateService';
import { UserModule } from '@/store/modules/User';

@Component({})
export default class CertificateComponent extends Vue {

	get apiUrl() {
		return config.apiUrl;
	}

	get accessToken() {

		// Get token from user module
		return UserModule.accessToken;
	}
}
